import {
  IHealthFundCard,
  IHealthFundProvider,
} from '@principle-theorem/principle-core/interfaces';

export interface IHealthFundCardLookup extends IHealthFundCard {
  matchingFunds?: IHealthFundProvider[];
  cardNumber?: string;
}
